(function () {
	"use strict";

	angular.module("swurveys.maker")
	.controller("previewerController", Handler);

	function Handler($scope, sliderService, utilsService) {

		$scope.slider = sliderService.getSlider();

		var editor = $scope.$parent;

		var referralCard = {
			id : "signupCard",
			type: "binary",
			left: {
				"choice": "No"
			},
			right: {
				"choice": "Yes"
			}
		}

		var leadGenCard = {
			id : "leadgenCard",
			type: "leadgen"
		}

		var extendedFeedbackCard = {
			id : "extendedFeedbackCard",
			type: "extendedFeedback"
		}

		$scope.cardStack = {
			WOT: {
				inEditor: true,
				percentage: 99,
				answer: "YES",
				question: "<b>Should I Use Swurveys?</b>"
			},
			currentCards: function () {
				$scope.deckSize = $scope.selectedSwurvey.model.cards.length;
				if($scope.navTab == "extras" && $scope.selectedSwurvey.model.options)
				{
					if($scope.selectedSwurvey.model.options.referralCard && $scope.selectedSwurvey.model.options.referralCard.enabled)
					{
						var text = $scope.selectedSwurvey.model.options.referralCard.text;
						if(!text)
						{
							text = utilsService.defaultText.referralCard;
						}
						referralCard.text =  "<div class='text-center'><img src='https://app.swurveys.com/assets/swurveyslogo.png'/><p>" + text + "</p><div>";
						return [referralCard];
					}
					if($scope.selectedSwurvey.model.options.leadgen && $scope.selectedSwurvey.model.options.leadgen.enabled)
					{
						leadGenCard.text = $scope.selectedSwurvey.model.options.leadgen.text
						if(!leadGenCard.text)
						{
							leadGenCard.text = utilsService.defaultText.leadGen;
						}
						return [leadGenCard];
					}
					if($scope.selectedSwurvey.model.options.extendedFeedback && $scope.selectedSwurvey.model.options.extendedFeedback.enabled)
					{
						extendedFeedbackCard.text = $scope.selectedSwurvey.model.options.extendedFeedback.text
						if(!extendedFeedbackCard.text)
						{
							extendedFeedbackCard.text = utilsService.defaultText.extendedFeedback;
						}
						return [extendedFeedbackCard];
					}
				}
				return [$scope.selectedSwurvey.model.cards[editor.cardTab] || $scope.selectedSwurvey.model.cards[0]];
			},
			previous: function () {
				sliderService.normalizeSliderState($scope);
				if(editor.cardTab > 0)
				editor.switchNavTab(~-editor.cardTab);
			},
			next: function () {
				sliderService.normalizeSliderState($scope);

				if(editor.cardTab < $scope.selectedSwurvey.model.cards.length)
				editor.switchNavTab(-~editor.cardTab);
			},
			reset: function () {
				console.log("RESETTING!");
				editor.switchNavTab(0);
				sliderService.normalizeSliderState($scope);
				$scope.cardStack.currentCards();
			},
			currentCardIndex: function () {
				return -~(editor.cardTab || 0);
			},
		}
	};
}());
